import { render } from "./ArrowIcon.vue?vue&type=template&id=5c263c87&scoped=true"
import script from "./ArrowIcon.vue?vue&type=script&lang=js"
export * from "./ArrowIcon.vue?vue&type=script&lang=js"

import "./ArrowIcon.vue?vue&type=style&index=0&id=5c263c87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c263c87"]])

export default __exports__